import React, { Component } from 'react'

import Carousel from './Carousel'
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div id="Home">
        <Carousel categories={this.props.categories}/>
        <div className="homeP">
          <p>
            We are here for you to turn your idea into a garden of your dreams. 
            We deliver all types of gardening and landscaping services, custom built solutions and many more. 
            Feel free to <a href="/contact">contact us</a> to arrange a consultation to find out how we can help.
          </p>
        </div>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.jsx